












import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class FooterItem extends Vue {
    @Prop({ type: Boolean, required: true }) readonly hasMT!: Boolean;
    @Prop({ type: String, required: true }) readonly title!: String;
    @Prop({ type: Array, required: true }) readonly links!: Array<String>;
    @Prop({ type: String, required: false }) readonly menuShown!: String;
    @Prop({ type: Function, required: true }) readonly setMenuShown!: Function;
}
